module.exports = __webpack_public_path__ + "static/media/flagGreen.dc4235fa.svg";